var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "webdatalist" }, [
    _c(
      "div",
      { staticClass: "showLargeScreenOnly" },
      _vm._l(_vm.clearanceGroups, function (group) {
        return _c(
          "div",
          [
            !_vm.isEmpty(_vm.filteredUserAccounts[group.clearance])
              ? _c("f7-block-title", [_vm._v(_vm._s(group.label))])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "f7-list",
              { attrs: { "media-list": "" } },
              _vm._l(
                _vm.filteredUserAccounts[group.clearance],
                function (group, key) {
                  return _c(
                    "f7-list-group",
                    { key: key },
                    [
                      _c("f7-list-item", {
                        attrs: { title: key, "group-title": "" },
                      }),
                      _vm._v(" "),
                      _vm._l(group, function (data) {
                        return _c("li", { key: data.id }, [
                          _c(
                            "div",
                            { staticClass: "item-content boxRequest" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item-inner",
                                  on: {
                                    click: function ($event) {
                                      return _vm.editAccountMember(data)
                                    },
                                  },
                                },
                                [
                                  _c("div", { staticClass: "item-title" }, [
                                    _vm._v(_vm._s(data.login)),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "item-subtitle" }, [
                                    _vm._v(_vm._s(data.active)),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "item-media" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "button-swipe-out",
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeAccountMemberWeb(data)
                                      },
                                    },
                                  },
                                  [
                                    _c("f7-icon", {
                                      staticClass: "button-delete",
                                      style: _vm.$engine
                                        .firstOn()
                                        .rights.rightIs(
                                          "business_members_delete",
                                          false
                                        )
                                        ? { color: "grey" }
                                        : {},
                                      attrs: {
                                        f7: "close",
                                        disabled: _vm.$engine
                                          .firstOn()
                                          .rights.rightIs(
                                            "business_members_delete",
                                            false
                                          ),
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                        ])
                      }),
                    ],
                    2
                  )
                }
              ),
              1
            ),
          ],
          1
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "showSmallScreenOnly" },
      _vm._l(_vm.clearanceGroups, function (group) {
        return _c(
          "div",
          [
            !_vm.isEmpty(_vm.filteredUserAccounts[group.clearance])
              ? _c("f7-block-title", [_vm._v(_vm._s(group.label))])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "f7-list",
              { attrs: { "media-list": "" } },
              _vm._l(
                _vm.filteredUserAccounts[group.clearance],
                function (group, key) {
                  return _c(
                    "f7-list-group",
                    { key: key },
                    [
                      _c("f7-list-item", {
                        attrs: { title: key, "group-title": "" },
                      }),
                      _vm._v(" "),
                      _vm._l(group, function (data) {
                        return _c(
                          "li",
                          { key: data.id, staticClass: "swipeout" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "item-content boxRequest swipeout-content",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "item-inner",
                                    on: {
                                      click: function ($event) {
                                        return _vm.editAccountMemberMobile(data)
                                      },
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "item-title" }, [
                                      _vm._v(_vm._s(data.login)),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "item-subtitle" },
                                      [_vm._v(_vm._s(data.active))]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "swipeout-actions-right" },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "swipeout-create action3",
                                    attrs: { href: "#" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.editAccountMemberMobile(data)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(_vm.$t("rights.edit")) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "action4",
                                    class: _vm.$engine
                                      .firstOn()
                                      .rights.rightIs(
                                        "business_members_delete",
                                        false
                                      )
                                      ? ""
                                      : "swipeout-delete",
                                    style: _vm.$engine
                                      .firstOn()
                                      .rights.rightIs(
                                        "business_members_delete",
                                        false
                                      )
                                      ? "background-color:grey"
                                      : "",
                                    attrs: { href: "#", delete: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeAccountMember(data)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(_vm.$t("common.rm_label")) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  )
                }
              ),
              1
            ),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }